import { gsap } from 'gsap';

export function animations() {
	gsap.utils.toArray('.js-content-block').forEach((contentBlock) => {
		gsap.from(contentBlock, {
			y: 20,
			duration: 1.2,
			ease: 'power2.out',
			scrollTrigger: {
				trigger: contentBlock,
				start: 'top bottom',
				end: 'bottom 30%',
				toggleActions: 'play none none reverse',
			},
		});
		gsap.from(
			contentBlock,
			{
				autoAlpha: 0,
				duration: 0.3,
				ease: 'none',
				scrollTrigger: {
					trigger: contentBlock,
					start: 'top bottom',
					end: 'bottom 30%',
					toggleActions: 'play none none reverse',
				},
			},
			'-=0.7',
		);
	});
}
